// third-party
import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
    documentType: []
};

// ==============================|| SLICE - ARCHIVE ||============================== //

const archive = createSlice({
    name: 'archive',
    initialState,
    reducers: {
        setDocumentType(state, action) {
            state.documentType = action.payload;
        }
    }
});

export default archive.reducer;

export const { setDocumentType } = archive.actions;
